(() => {
  const parseDate = (value) => {
    if (!value) return null;
    const time = Date.parse(value);
    return Number.isNaN(time) ? null : time;
  };

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const initBar = (bar) => {
    if (bar.dataset.k2Ready === 'true') return;
    bar.dataset.k2Ready = 'true';

    const storageKey = `k2-announcement-${bar.dataset.sectionKey}`;
    if (bar.dataset.dismissible === 'true') {
      try {
        const until = Number(localStorage.getItem(storageKey) || 0);
        if (until > Date.now()) bar.hidden = true;
      } catch (_) {}
    }

    bar.querySelector('[data-k2-announcement-dismiss]')?.addEventListener('click', () => {
      const days = Number(bar.dataset.dismissDays || 7);
      try { localStorage.setItem(storageKey, String(Date.now() + days * 86400000)); } catch (_) {}
      bar.hidden = true;
      document.dispatchEvent(new CustomEvent('theme:resize'));
    });

    const items = [...bar.querySelectorAll('[data-k2-announcement-item]')];
    const update = () => {
      const now = Date.now();
      items.forEach((item) => {
        const start = parseDate(item.dataset.startAt);
        const end = parseDate(item.dataset.endAt);
        if (start && now < start) { item.hidden = true; return; }
        if (!end) { item.hidden = false; return; }

        const remaining = end - now;
        const countdown = item.querySelector('[data-k2-countdown]');
        const expiredText = item.querySelector('[data-k2-expired-text]');
        if (remaining <= 0) {
          const behavior = item.dataset.expiredBehavior;
          if (behavior === 'hide_block') item.hidden = true;
          else {
            item.hidden = false;
            if (countdown) countdown.hidden = true;
            if (behavior === 'show_expired' && expiredText) expiredText.hidden = false;
          }
          return;
        }

        item.hidden = false;
        if (!countdown || item.dataset.countdownDisabled === 'true') return;
        countdown.hidden = false;
        if (expiredText) expiredText.hidden = true;
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        countdown.querySelector('[data-k2-days]').textContent = pad(days);
        countdown.querySelector('[data-k2-hours]').textContent = pad(hours);
        countdown.querySelector('[data-k2-minutes]').textContent = pad(minutes);
        countdown.querySelector('[data-k2-seconds]').textContent = pad(seconds);
        const daysWrap = countdown.querySelector('[data-k2-days-wrap]');
        const secondsWrap = countdown.querySelector('[data-k2-seconds-wrap]');
        if (daysWrap) daysWrap.hidden = countdown.dataset.showDays !== 'true' || days === 0;
        if (secondsWrap) secondsWrap.hidden = countdown.dataset.showSeconds !== 'true';
      });
    };

    update();
    const timer = window.setInterval(update, 1000);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target?.contains(bar)) window.clearInterval(timer);
    }, { once: true });
  };

  const init = (root = document) => root.querySelectorAll('[data-k2-announcement]').forEach(initBar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
